export const MAX_Z_INDEX = 999999-1

export const MAX_NETWORK_LOADER_Z_INDEX = 10000-1